import React from 'react';
import { Typography } from '@mui/material';
import { MoSpacing } from '@motivo/guanyin/src/components';
import { ResultOf } from ':src/graphql';
import { userDetailsByIdQuery } from '../../graphql/queries';
import { formatDate } from '../../utils/dateFormatting';
import { SectionItem } from '../Section';
import LicenseText from './LicenseText';
import ZeusOrganizationLink from '../shared/ZeusOrganizationLink';

type User = NonNullable<ResultOf<typeof userDetailsByIdQuery>['userById']>;

interface BasicInfoProps {
  user: User;
}

export default function BasicInfo({ user }: BasicInfoProps) {
  const { superviseeProfile } = user;
  const stateAbbreviation = superviseeProfile?.licensureUsState?.abbreviation;
  const licenseDisplayName =
    superviseeProfile?.license?.displayName || superviseeProfile?.licenseCategory?.abbreviation;

  return (
    <MoSpacing y={1}>
      <SectionItem label="Email">{user.email}</SectionItem>
      {user.phone && <SectionItem label="Phone">{user.phone}</SectionItem>}
      {user.organizationUser?.organization && (
        <SectionItem label="Employer">
          <ZeusOrganizationLink organization={user.organizationUser.organization} />
          {user.organizationUser.organizationProgram && (
            <Typography variant="body2" color="text.primary">
              {user.organizationUser.organizationProgram.name}
            </Typography>
          )}
        </SectionItem>
      )}
      {stateAbbreviation && licenseDisplayName && (
        <SectionItem label="Seeking license">
          <LicenseText
            color="textPrimary"
            stateAbbreviation={stateAbbreviation}
            licenseDisplayName={licenseDisplayName}
          />
        </SectionItem>
      )}
      {user.createdAt && <SectionItem label="Created at">{formatDate(user.createdAt)}</SectionItem>}
    </MoSpacing>
  );
}
